<script>
    import Vue from 'vue';
    export default {
        data() {
            return {
                open: false,
                current: 0,
                selection: '',
                blurTimer: null
            }
        },
        props: {
            viewId: String,
            suggestions: Array,
            selectedModel: Object,
            placeholder: String,
            changeEvery: {
              type: Boolean,
              required: false,
              default: false
            }
            // selection: String
            // suggestions: {
            //     type: Array,
            //     required: true
            // },
            // selection: {
            //     type: String,
            //     required: true,
            //     twoWay: true
            // }
        },
        created(){
            let _self = this;
            this.$topnavbar.$on('clearACObject', () => {
                _self.selection = '';
                this.$emit('update:selectedModel',  '')
            });
            this.$topnavbar.$on('newItemSetToAutocomplete' + this.viewId, (data) => {
              if(data !== _self.selection){
                _self.selection = data;
                _self.open = false
              }
            });
        },
        computed: {
            matches() {
                const list = Array.isArray(this.suggestions) ? this.suggestions : [];
                const selection = this.fixNull(this.selection).toLowerCase();
                return list.filter((str) => {
                    return this.fixNull(str).toLowerCase().indexOf(selection) >= 0;
                });
            },
            openSuggestion() {
                return this.matches.length !== 0 && this.open === true;
            }
        },
        methods: {
            enter() {
                if (!this.matches || this.matches.length === 0) return;
                if (this.current >= this.matches.length) this.current = 0;
                this.$emit('update:selectedModel',  this.matches[this.current])
                // this.$emit('selected-model', this.matches[this.current])
                this.selection = this.matches[this.current];
                this.open = false;
            },
            fixNull(item){
              if(item == null) return ''
              return item;
            },
            up() {
                if(this.current > 0)
                    this.current--;
            },
            down() {
                if(this.current < this.matches.length - 1)
                    this.current++;
            },
            isActive(index) {
                return index === this.current;
            },
            onFocus() {
                if (this.blurTimer != null) {
                    clearTimeout(this.blurTimer);
                    this.blurTimer = null;
                }
                this.open = true;
                this.current = 0;
            },
            onBlur() {
                const _self = this;
                this.blurTimer = setTimeout(() => {
                    _self.open = false;
                }, 120);
            },
            change(event) {
                if(this.changeEvery === true){
                  const newValue = event.target.value;
                  this.$emit('update:selectedModel',  newValue)
                }
                if (this.open === false) {
                    this.open = true;
                    this.current = 0;
                }
            },
            suggestionClick(index) {
                if (!this.matches || this.matches.length === 0 || this.matches[index] == null) return;
                if (this.blurTimer != null) {
                    clearTimeout(this.blurTimer);
                    this.blurTimer = null;
                }
                this.$emit('update:selectedModel',  this.matches[index])
                this.selection = this.matches[index];
                this.open = false;
            },
        }
    }
</script>
<template>
  <div class="autocomplete-wrapper" v-bind:class="{'open':openSuggestion}">
    <input class="form-control input" type="text" v-model="selection"
           v-bind:placeholder="placeholder"
           autocomplete="off"
           autocorrect="off"
           autocapitalize="off"
           spellcheck="false"
           @keydown.enter = 'enter'
           @keydown.down = 'down'
           @keydown.up = 'up'
           @input = 'change'
           @focus='onFocus'
           @blur='onBlur'
    />
    <ul class="dropdown-menu autocomplete-dropdown">
      <li v-for="(suggestion,index) in matches"
          :key="index + '_' + suggestion"
          v-bind:class="{'active': isActive(index)}"
          @mousedown.prevent="suggestionClick(index)"
          @click.prevent="suggestionClick(index)">
        <a class="clickable">{{ suggestion }}</a>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// AutocompleteObject.vue?ffc516a0